export type MaxxAnalysisStatus = 'running' | 'ready' | 'failed';

export type MaxxTriggerState = 'empty' | 'filled' | 'running' | 'failed';

export interface MaxxAnalysisError {
  message: string;
  retryable: boolean;
}

export interface MaxxAnalysisResponse {
  testId: string;
  status: MaxxAnalysisStatus;
  threadId: number | null;
  answer: string | null;
  isRegenerating: boolean;
  error: MaxxAnalysisError | null;
}

export interface MaxxAnalysisStatusItem {
  testId: string;
  state: MaxxTriggerState;
  answer: string | null;
  threadId: number | null;
}

export interface MaxxAnalysisStatusResponse {
  items: MaxxAnalysisStatusItem[];
}

export interface MaxxAnalysisRowState {
  status: 'idle' | 'loading' | 'loaded' | 'error';
  inFlight: boolean;
  expanded: boolean;
  answer: string | null;
  threadId: number | null;
  errorRetryable: boolean;
  errorMessage: string | null;
}

export const MAXX_ANALYSIS_POLL_INTERVAL_MS = 2000;
export const MAXX_ANALYSIS_POLL_SLOW_INTERVAL_MS = 5000;
export const MAXX_ANALYSIS_POLL_SLOWDOWN_AFTER_MS = 30_000;
export const MAXX_ANALYSIS_POLL_TIMEOUT_MS = 300_000;
export const MAXX_ANALYSIS_REQUEST_TIMEOUT_MS = 30_000;

export const MAXX_TRIGGER_TOOLTIP_ANALYZE = 'Analyze with MAXX';
export const MAXX_TRIGGER_TOOLTIP_VIEW = 'View MAXX analysis';

export const MAXX_ERROR_RETRYABLE = "MAXX couldn't complete the analysis. Please try again.";
export const MAXX_ERROR_NON_RETRYABLE = 'Please contact support if the problem persists';

export function createIdleRowState(): MaxxAnalysisRowState {
  return {
    status: 'idle',
    inFlight: false,
    expanded: false,
    answer: null,
    threadId: null,
    errorRetryable: false,
    errorMessage: null,
  };
}
